import * as yup from "yup";

export type SplitListingValidationType = yup.InferType<typeof SplitListingValidation>;

export const SplitListingValidation = yup.object().shape({
	Quantity: yup.number().typeError("").required("").max(yup.ref("$maxQuantity"), ""),
	Ticket_Price: yup
		.number()
		.typeError("")
		.required("")
		.notOneOf([yup.ref("$currentPrice")], ""),
	Split_In_Groups: yup.boolean().required(),
});
